export default __webpack_public_path__ + "8d5e5d003438b4657b629aacc5f3aa30.png";